module.exports = __webpack_public_path__ + "src/img/artist/work08_4.jpg?e27a4f14fff10c14b60d8d1bfdfcc817";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work08_4.jpg
// module id = 163
// module chunks = 0